import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import {RestrictedToAdmin} from "components/auth";
import Card from "components/card";
import FormTextField from "components/form/form-textfield";
import {FormattedMessage, injectIntl} from "react-intl";
import DataGrid, {DataGridItem} from "components/data-grid";
import {EventTypeSelectMultiple, PartnerSelect, ProductionTypeSelectMultiple} from "components/select";
import withStyles from "components/with-styles";
import styles from "./styles/form.css.js";
import FormCheckbox from "components/form/form-checkbox";
import {DeploymentAutocompleteSelectForm} from "components/autocomplete";
import Restricted from "../../../../components/auth/restricted/restricted";
import permissions from "../../../../components/auth/restricted/permissions";
import { deletePartnerForCustomer } from "../../../../services/commonService.js";

const NewContractForm = ({intl, values, handleChange, classes}) => {
    return (
        <>
            <DataGridItem>
                <FormTextField
                    type="text"
                    id="name"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    label={intl.formatMessage({id: "common.name"})}
                />
            </DataGridItem>
            <DataGridItem>
                <FormTextField
                    type="text"
                    id="description"
                    name="description"
                    value={values.description}
                    onChange={handleChange}
                    label={intl.formatMessage({id: "common.description"})}
                />
            </DataGridItem>
            <DataGridItem>
                <DeploymentAutocompleteSelectForm
                    id="deploymentId"
                    name="deploymentId"
                    placeholder={intl.formatMessage({id: "app.page.deployment.list.search"})}
                    label={intl.formatMessage({id: "contract.deployment"})}
                    value={values.deploymentId}
                    onChange={handleChange}
                />
            </DataGridItem>
            <DataGridItem>
                <EventTypeSelectMultiple
                    className={classes.multipleSelect}
                    isInsideForm
                    label={intl.formatMessage({id: "contract.allowedEventTypes"})}
                    onChange={handleChange}
                    value={values.allowedEventTypes}
                />
            </DataGridItem>
            <DataGridItem>
                <ProductionTypeSelectMultiple
                    className={classes.multipleSelect}
                    isInsideForm
                    label={intl.formatMessage({id: "contract.allowedProductionTypes"})}
                    onChange={handleChange}
                    value={values.allowedProductionTypes}
                />
            </DataGridItem>
            <DataGridItem>
                <FormTextField
                    type="number"
                    id="liveCommentatorSupport"
                    name="liveCommentatorSupport"
                    value={values.liveCommentatorSupport}
                    onChange={handleChange}
                    label={intl.formatMessage({id: "contract.liveCommentatorSupport"})}
                />
            </DataGridItem>
            <DataGridItem>
                <FormTextField
                    type="number"
                    id="keepVideosForMonths"
                    name="keepVideosForMonths"
                    value={values.keepVideosForMonths}
                    onChange={handleChange}
                    label={intl.formatMessage({id: "contract.keepVideosForMonths"})}
                />
            </DataGridItem>
            <DataGridItem>
                <FormTextField
                    type="number"
                    id="monthlyTiiviiHours"
                    name="monthlyTiiviiHours"
                    value={values.monthlyTiiviiHours}
                    onChange={handleChange}
                    label={intl.formatMessage({id: "contract.monthlyTiiviiHours"})}
                />
            </DataGridItem>
            <DataGridItem>
                <FormCheckbox
                    id="allowedMasterStreamSave"
                    name="allowedMasterStreamSave"
                    value="allowedMasterStreamSave"
                    checked={values.allowedMasterStreamSave}
                    onChange={handleChange}
                    label={intl.formatMessage({id: "contract.allowedMasterStreamSave"})}
                />
            </DataGridItem>
            <Restricted permissions={[permissions.customer_manage]}>
            <DataGridItem>
                <div>
                    <FormCheckbox
                        name="tiiviiOttConfig.enabled"
                        value="tiiviiOttConfig.enabled"
                        checked={values.tiiviiOttConfig?.enabled}
                        onChange={handleChange}
                        label={intl.formatMessage({id: "contract.ottConfigEnabledField"})}/>
                    {values.tiiviiOttConfig?.enabled && <>
                        <FormTextField
                            name="tiiviiOttConfig.webhookUrl"
                            value={values.tiiviiOttConfig?.webhookUrl}
                            onChange={handleChange}
                            fullWidth
                            label={intl.formatMessage({id: "contract.ottconfig.webhook"})}
                        />
                        <FormTextField
                            name="tiiviiOttConfig.nimbleConfigUrl"
                            value={values.tiiviiOttConfig?.nimbleConfigUrl}
                            onChange={handleChange}
                            fullWidth
                            label={intl.formatMessage({id: "contract.ottconfig.nimbleconfigurl"})}
                        />
                    </>}
                </div>
                </DataGridItem>
            </Restricted>
            <RestrictedToAdmin excludePartners>
                <Card>
                    <DataGrid>
                        <DataGridItem>
                            <Typography variant="h6">
                                <FormattedMessage id="app.page.user.associateToPartner"/>
                            </Typography>
                            <PartnerSelect
                                isInsideForm
                                label={intl.formatMessage({id: "app.partner"})}
                                onChange={name => value => handleChange(name)(value)}
                                value={values.ownedByPartnerId}
                            />
                        </DataGridItem>
                    </DataGrid>
                </Card>
            </RestrictedToAdmin>
        </>
    );
}
NewContractForm.propTypes = {
    /**
     * Valores del formulario
     */
    values: PropTypes.object,
    /**
     * Callback que se dispara con el cambio del input
     */
    handleChange: PropTypes.func,
};

export default withStyles(styles)(injectIntl(NewContractForm));
